import React from 'react';
import '../styles/Page.css';

const Contact: React.FC = () => {
  return (
    <div className="page">
      <div className="page__container">
        <header className="page__header">
          <h1 className="page__title">
            <span className="page__title--glitch" data-text="CONTACT">CONTACT</span>
            <span className="page__subtitle">COMM_LINK_ESTABLISHED</span>
          </h1>
          <p className="page__description">
            Establish secure communication channels to initiate contact protocols.
          </p>
        </header>

        <div className="contact__grid">
          <div className="contact__card">
            <div className="contact__header">
              <h3 className="contact__title">🌐 Digital Presence</h3>
            </div>
            <div className="contact__content">
              <div className="contact__item">
                <span className="contact__label">Email:</span>
                <span className="contact__value">griffincancode@gmail.com</span>
              </div>
              <div className="contact__item">
                <span className="contact__label">LinkedIn:</span>
                <span className="contact__value">linkedin.com/in/griffin-architect</span>
              </div>
              <div className="contact__item">
                <span className="contact__label">GitHub:</span>
                <span className="contact__value">github.com/GriffinCanCode</span>
              </div>
            </div>
          </div>

          <div className="contact__card">
            <div className="contact__header">
              <h3 className="contact__title">⚡ Real-time Chat</h3>
            </div>
            <div className="contact__content">
              <div className="contact__item">
                <span className="contact__label">Discord:</span>
                <span className="contact__value">Griffin#0001</span>
              </div>
              <div className="contact__item">
                <span className="contact__label">Slack:</span>
                <span className="contact__value">@griffin.matrix</span>
              </div>
              <div className="contact__item">
                <span className="contact__label">Status:</span>
                <span className="contact__value contact__status--online">ONLINE</span>
              </div>
            </div>
          </div>

          <div className="contact__card">
            <div className="contact__header">
              <h3 className="contact__title">🔐 Secure Channels</h3>
            </div>
            <div className="contact__content">
              <div className="contact__item">
                <span className="contact__label">PGP Key:</span>
                <span className="contact__value">4A3E 2B1F 9C8D 7E6A</span>
              </div>
              <div className="contact__item">
                <span className="contact__label">Signal:</span>
                <span className="contact__value">+1-XXX-MATRIX</span>
              </div>
              <div className="contact__item">
                <span className="contact__label">Encryption:</span>
                <span className="contact__value">AES-256</span>
              </div>
            </div>
          </div>

          <div className="contact__card">
            <div className="contact__header">
              <h3 className="contact__title">🏢 Professional</h3>
            </div>
            <div className="contact__content">
              <div className="contact__item">
                <span className="contact__label">Location:</span>
                <span className="contact__value">The Matrix</span>
              </div>
              <div className="contact__item">
                <span className="contact__label">Timezone:</span>
                <span className="contact__value">UTC+00:00</span>
              </div>
              <div className="contact__item">
                <span className="contact__label">Availability:</span>
                <span className="contact__value">24/7 Neural Link</span>
              </div>
            </div>
          </div>
        </div>

        <div className="page__terminal">
          <div className="terminal__line">
            <span className="terminal__prompt">griffin@matrix:~/contact$</span>
            <span className="terminal__command">ping griffin@matrix.digital</span>
          </div>
          <div className="terminal__output">
            <div>PING griffin@matrix.digital (192.168.1.100): 56 data bytes</div>
            <div>64 bytes from 192.168.1.100: icmp_seq=0 time=0.042ms</div>
            <div>64 bytes from 192.168.1.100: icmp_seq=1 time=0.037ms</div>
            <div>64 bytes from 192.168.1.100: icmp_seq=2 time=0.033ms</div>
            <div>--- griffin@matrix.digital ping statistics ---</div>
            <div>3 packets transmitted, 3 received, 0% packet loss</div>
            <div style={{ color: 'var(--matrix-primary)' }}>CONNECTION ESTABLISHED ✓</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact; 